import { createFileRoute } from '@tanstack/react-router'

import { UnderConstruction } from '@/components/block/common/under-construction'

export const Route = createFileRoute('/_app/finance/')({
  component: UnderConstruction,
})
